import { defineMessages } from 'react-intl';

type MessageKeys = 'refineButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		refineButton: {
			id: 'fabric.editor.ai.screens.preview.refineDropdown.refineButton',
			defaultMessage: 'Refine',
			description: 'The action text for the refine button to edit the previewed generated content',
		},
	});

export default message;
